module.exports = __webpack_public_path__ + "static/media/combat.7186bc8a.mp4";